import { useEffect } from 'react';

// Import utilities
import { useAuth, useProtectedPage } from 'components/utilities';

export const useClearProtectedPage = () => {
	const { isAuth } = useAuth();
	const clear = useProtectedPage((state) => state.clearProtectedPage);

	useEffect(() => {
		isAuth && clear();
	}, []);
};
